import React from 'react';

import styles from './styles.css';

export interface IPageIndicatorProps {
  count: number;
  activeIndex: number;
}

export const PageIndicator: React.FC<IPageIndicatorProps> = ({ count, activeIndex }) => {
  return (
    <div className={styles.root} role="tablist" aria-label="Страницы">
      {Array.from({ length: count }, (_, index) => (
        <span
          key={index}
          className={index === activeIndex ? styles['dot-active'] : styles.dot}
          role="tab"
          aria-selected={index === activeIndex}
        />
      ))}
    </div>
  );
};

PageIndicator.displayName = 'PageIndicator';
